import { useState, useEffect, useRef } from "react";

export default function ChatBox() {
  const [open, setOpen] = useState(false);
  const [minimized, setMinimized] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const [showIntro, setShowIntro] = useState(false);
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);
  const [closing, setClosing] = useState(false);

  const messagesEndRef = useRef(null);

  // INTRO POPUP: apare după 1.5 sec
  useEffect(() => {
    const timer = setTimeout(() => setShowIntro(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  // INTRO POPUP: dispare după 5 sec
  useEffect(() => {
    if (!showIntro) return;
    const hide = setTimeout(() => setShowIntro(false), 5000);
    return () => clearTimeout(hide);
  }, [showIntro]);

  // Detectare schimbare pagină → ascunde intro popup
  useEffect(() => {
    const hidePopup = () => setShowIntro(false);

    window.addEventListener("popstate", hidePopup);
    window.addEventListener("pushstate", hidePopup);
    window.addEventListener("replacestate", hidePopup);

    return () => {
      window.removeEventListener("popstate", hidePopup);
      window.removeEventListener("pushstate", hidePopup);
      window.removeEventListener("replacestate", hidePopup);
    };
  }, []);

  // PATCH pentru a prinde pushState / replaceState (SPA routing)
  if (!window._patchedHistory) {
    window._patchedHistory = true;

    ["pushState", "replaceState"].forEach((type) => {
      const original = history[type];
      history[type] = function () {
        const result = original.apply(this, arguments);
        window.dispatchEvent(new Event(type.toLowerCase()));
        return result;
      };
    });
  }

  // scroll automat la ultimul mesaj
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, typing]);

const openChat = () => {
  setOpen(true);
  setMinimized(false);

  if (messages.length === 0) {
    // 1. Pornește animația de typing
    setTyping(true);

    // 2. După 1.2 secunde trimite mesajul de întâmpinare
    setTimeout(() => {
      setTyping(false);

      setMessages([
        {
          from: "bot",
          text: "Bun venit la Artisan Stoma 👋 Eu sunt Aria, asistenta ta virtuală. Cu ce vă pot ajuta astăzi?",
        },
      ]);
    }, 500);
  }
};


  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = input;

    setMessages((prev) => [...prev, { from: "user", text: userMessage }]);
    setInput("");

    setTyping(true);

    try {
      const res = await fetch("https://fascinating-mab-artisanstoma-04e1cb26.koyeb.app/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userMessage }),
      });

      const data = await res.json();

      setTyping(false);

      setMessages((prev) => [...prev, { from: "bot", text: data.response }]);
    } catch (error) {
      setTyping(false);

      setMessages((prev) => [
        ...prev,
        { from: "bot", text: "A apărut o eroare. Serverul nu răspunde." },
      ]);
    }
  };
const [closingIntro, setClosingIntro] = useState(false);

  return (
    <>
      {/* INTRO POPUP */}
{showIntro && !open && (
  <div
    onClick={openChat}
    className={`
      fixed bottom-28 right-5
      bg-white shadow-xl border border-gray-200
      px-4 py-3 rounded-xl text-sm w-64 z-[60]
      intro-popup ${closingIntro ? "intro-popup-hide" : ""}
    `}
  >
    👋 Buna! Eu sunt Aria , asistenta ta virtuală.  
    Sunt aici să vă ajut cu informații rapide.
  </div>
)}

      {/* BUTTON */}
      {!open && (
        <div
  onClick={openChat}
  className="fixed bottom-5 right-5 bg-blue-600 text-white px-6 py-4 rounded-full shadow-xl cursor-pointer 
             hover:bg-blue-700 transition-all z-[50] flex items-center gap-2 animate-pulseSoft"
>
  <span className="text-xl">💬</span>
  <span className="font-semibold">Asistent Virtual</span>
</div>

      )}

      {/* CHAT WINDOW */}
      {open && (
<div
  className={`
    fixed z-[100]

    /* MOBILE – complet centrat fără nicio tranziție */
    left-1/2 -translate-x-1/2 bottom-5

    /* DESKTOP – mutat în dreapta */
    md:left-auto md:translate-x-0 md:right-5 md:bottom-5

    ${minimized ? "h-14 w-80" : "w-96 h-[520px]"}

    bg-white border border-gray-300 rounded-2xl shadow-2xl overflow-hidden

    transition-[transform,opacity,width,height] duration-300 ease-[cubic-bezier(.4,0,.2,1)]

    ${closing ? "animate-chatClose" : "animate-chatOpen"}
  `}
>

          {/* HEADER */}
          <div className="flex justify-between items-center px-4 py-3 bg-blue-600 text-white">
            <strong>Aria – Asistentul Artisan Stoma</strong>

 <div className="flex gap-3 text-xl">

  {/* BUTON MINIMIZE / RESTORE */}
  {!minimized ? (
    // Minimize button
    <button onClick={() => setMinimized(true)}> _ </button>
  ) : (
    // Restore button
    <button onClick={() => setMinimized(false)}>▢</button>
  )}

  {/* BUTON CLOSE – doar dacă NU este minimizat */}
  {!minimized && (
    <button onClick={() => setShowCloseConfirm(true)}>×</button>
  )}

</div>
          </div>

          {/* CONFIRM CLOSE */}
          {showCloseConfirm && (
            <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
              <div className="bg-white rounded-xl p-6 w-64 shadow-xl text-center">
                <p className="mb-4 text-gray-800">
                  Sigur doriți să închideți conversația?
                </p>
                <div className="flex justify-center gap-4">
                  <button
                    className="px-4 py-2 bg-gray-200 rounded-lg"
                    onClick={() => setShowCloseConfirm(false)}
                  >
                    Nu
                  </button>
                  <button
                    className="px-4 py-2 bg-red-600 text-white rounded-lg"
                    onClick={() => {
  setShowCloseConfirm(false);
  setClosing(true);

  setTimeout(() => {
    setClosing(false);
    setOpen(false);
    setMessages([]);
  }, 250); // durata animatiei
}}
                  >
                    Da
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* BODY */}
          {!minimized && (
            <>
              <div className="flex-1 p-4 overflow-y-auto space-y-3 h-[380px]">
                {messages.map((msg, i) => (
                  <div
                    key={i}
                    className={`px-3 py-2 rounded-xl max-w-[80%] leading-tight ${
                      msg.from === "user"
                        ? "bg-blue-200 ml-auto"
                        : "bg-gray-200"
                    }`}
                  >
                    {msg.text}
                  </div>
                ))}

                {/* TYPING INDICATOR */}
                {typing && (
                  <div className="bg-gray-200 px-3 py-2 rounded-xl w-14">
                    <div className="typing-dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                )}

                <div ref={messagesEndRef} />
              </div>

              {/* INPUT */}
              <div className="p-3 border-t flex gap-2">
                <input
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                  className="flex-1 border rounded-xl px-3 py-2"
                  placeholder="Scrie un mesaj…"
                />
                <button
                  onClick={sendMessage}
                  className="bg-blue-600 text-white px-4 rounded-xl hover:bg-blue-700 transition"
                >
                  Trimite
                </button>
              </div>
            </>
          )}
        </div>
      )}

      {/* TYPING ANIMATION CSS */}
      <style>{`
        .typing-dots {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
        }

        .typing-dots span {
          width: 6px;
          height: 6px;
          background: #555;
          border-radius: 50%;
          display: inline-block;
          animation: bounce 1s infinite;
        }

        .typing-dots span:nth-child(2) {
          animation-delay: 0.2s;
        }
        .typing-dots span:nth-child(3) {
          animation-delay: 0.4s;
        }

        @keyframes bounce {
          0% { transform: translateY(0); }
          30% { transform: translateY(-6px); }
          60% { transform: translateY(0); }
        }

        .animate-scaleIn {
          animation: scaleIn 0.25s ease-out;
        }
        @keyframes scaleIn {
          from { transform: scale(0.8); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }

        .animate-fadeIn {
          animation: fadeIn 0.8s ease;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
          @keyframes chatClose {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.85);
  }
}

.animate-chatClose {
  animation: chatClose 0.25s ease-out forwards;
}
@keyframes pulseSoft {
    0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.4); }
    50% { transform: scale(1.05); box-shadow: 0 0 15px 6px rgba(37, 99, 235, 0.25); }
    100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.4); }
  }

  .animate-pulseSoft {
    animation: pulseSoft 2.4s ease-in-out infinite;
  }
    /* Animatie intrare */
.intro-popup {
  opacity: 0;
  transform: translateY(15px) scale(0.95);
  animation: popupFadeIn 0.6s ease forwards;
}

@keyframes popupFadeIn {
  0% {
    opacity: 0;
    transform: translateY(15px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Animatie iesire */
.intro-popup-hide {
  animation: popupFadeOut 0.6s ease forwards !important;
}

@keyframes popupFadeOut {
  0% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(15px) scale(0.95);
  }
}


      `}</style>
    </>
  );
}
